module.exports = __webpack_public_path__ + "img/page.cb9f3a3b.png";